/*
 * Copyright, AlpineReplay, Inc. 2021. All rights reserved.
 * Author: Brian Bal
 */
import { clearToken } from "trux"
import { webApi } from "../../lib/WebApi"
import { readPlaylistForUser } from "../../lib/PlaylistApi"

let defaultValue = {
    loading: false,
    complete: false,
    error: null,
    value: null,
}

const loadUser = () => {
    return (dispatch, getState) => {
        let user = getState().user
        if (user.loading || user.complete) {
            // console.log("Loader.loadUser skip user update")
            return { type: "NOOP" }
        }

        dispatch({
            type: "COMMON_SET",
            key: "user",
            value: { loading: true, error: null },
            defaultValue: { ...defaultValue },
        })

        dispatch({
            type: "COMMON_SET",
            key: "isLoggedIn",
            value: null,
        })

        return webApi
            ._get("/webapp/users/self")
            .then((user) => {
                clearToken()
                dispatch({
                    type: "COMMON_SET",
                    key: "user",
                    value: {
                        loading: false,
                        complete: true,
                        value: user,
                        error: null,
                    },
                    defaultValue: { ...defaultValue },
                })
                dispatch({
                    type: "COMMON_SET",
                    key: "isLoggedIn",
                    value: true,
                })
                return user
            })
            .then((user) => {
                // load user playlist second to speed things up a bit
                if (user) {
                    return readPlaylistForUser(user).then((playlist) => {
                        user.traceid_playlist = playlist
                        return user
                    })
                } else {
                    return user
                }
            })
            .then((user) => {
                dispatch({
                    type: "COMMON_SET",
                    key: "user",
                    value: {
                        loading: false,
                        complete: true,
                        value: user,
                        error: null,
                    },
                    defaultValue: { ...defaultValue },
                })
                dispatch({
                    type: "COMMON_SET",
                    key: "isLoggedIn",
                    value: true,
                })
            })
            .catch((err) => {
                clearToken()
                dispatch({
                    type: "COMMON_SET",
                    key: "user",
                    value: {
                        loading: false,
                        complete: true,
                        value: null,
                        error: err,
                    },
                    defaultValue: { ...defaultValue },
                })
                dispatch({
                    type: "COMMON_SET",
                    key: "isLoggedIn",
                    value: false,
                })
            })
    }
}

export default loadUser
